import { styled } from '@mui/material';

const Div = styled('div')``;

export default Div;
